var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tr',[_c('td',{attrs:{"colspan":"3"}},[_vm._v(_vm._s(_vm.depName))])]),_vm._l((_vm.depInvoices),function(item,index){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.amount))]),_c('td',[_vm._v(_vm._s(item.amount))]),_c('td',[_vm._v(_vm._s(item.amount))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }